import { Component, OnInit, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';


@Component({
    selector: 'error-message',
    templateUrl: './errormessage.component.html',
    styleUrls: ['./errormessage.component.scss'],
    standalone: true,
    imports: []
})
export class ErrormessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  readonly errorControl = input<AbstractControl>(undefined);
  readonly touched = input<boolean>(false);
}
